import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = { class: "space-y-2 sm:flex" }
const _hoisted_6 = { class: "space-y-2 sm:flex sm:flex-1 sm:space-x-4" }
const _hoisted_7 = { class: "flex items-center text-sm text-gray-500" }
const _hoisted_8 = { class: "flex items-center text-sm text-gray-500" }
const _hoisted_9 = { class: "flex items-center text-sm text-gray-500" }
const _hoisted_10 = {
  key: 0,
  class: "font-medium text-green-600"
}
const _hoisted_11 = { class: "flex items-center text-sm text-gray-500" }
const _hoisted_12 = { class: "flex items-center text-sm text-gray-500" }

import { PropType } from 'vue';
import router from '@/router';

import {
    InformationCircleIcon,
    LocationMarkerIcon,
    TagIcon,
    UsersIcon,
} from '@heroicons/vue/solid';
import ConnectFlowIcon from '@/components/svg/ConnectFlowIcon';
import { PencilAltIcon } from '@heroicons/vue/outline';
import { NumberModel, Permission } from '@/types';
import { applyPhoneMask } from '@/utils/number';


export default /*@__PURE__*/_defineComponent({
  __name: 'NumberListItem',
  props: {
    modelValue: {
        type: Object as PropType<NumberModel>,
        required: true,
    },
},
  setup(__props) {



const handleEditClick = () => {
    router.push({
        name: 'EditNumberById',
        params: {
            id: __props.modelValue.id,
        },
    });
};

return (_ctx: any,_cache: any) => {
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _component_UiAuditInfo = _resolveComponent("UiAuditInfo")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_UiPanel, { class: "space-y-2 hover:bg-white" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$can(_unref(Permission).VIEW_NUMBER) ? 'RouterLink' : 'span'), {
            to: {
                        name: 'ViewNumberById',
                        params: {
                            id: __props.modelValue.id,
                        },
                    },
            class: "text-md text-primary truncate font-medium"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(applyPhoneMask)(__props.modelValue.number)), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        ]),
        (_ctx.$can(_unref(Permission).EDIT_NUMBER))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                variant: "primary",
                onClick: handleEditClick
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('core.actions.Edit')), 1),
                  _createVNode(_unref(PencilAltIcon), {
                    class: "h-6 w-6",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              })), [
                [_directive_tippy, _ctx.$t('core.actions.Edit')]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, [
            _createVNode(_unref(LocationMarkerIcon), {
              class: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString(__props.modelValue.city) + "/" + _toDisplayString(__props.modelValue.state), 1)
          ]),
          _createElementVNode("p", _hoisted_8, [
            _createVNode(_unref(InformationCircleIcon), {
              class: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`number.types.${__props.modelValue.type}`)), 1)
          ]),
          _createElementVNode("p", _hoisted_9, [
            _createVNode(_unref(ConnectFlowIcon), {
              class: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            (__props.modelValue.whatsappRouting?.isActive)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('number.list.whatsappRouting')), 1))
              : (_openBlock(), _createBlock(_resolveDynamicComponent(
                            _ctx.$can(_unref(Permission).VIEW_CONNECT_FLOW) && __props.modelValue.connectFlow?.id
                                ? 'RouterLink'
                                : 'span'
                        ), {
                  key: 1,
                  to: {
                            name: 'EditFlowById',
                            params: {
                                id: __props.modelValue.connectFlow?.id,
                            },
                        },
                  class: _normalizeClass([
                            _ctx.$can(_unref(Permission).VIEW_CONNECT_FLOW) &&
                                __props.modelValue.connectFlow?.id &&
                                'text-primary font-medium',
                        ])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.modelValue.connectFlow?.name || _ctx.$t('number.list.noConnectFlow')), 1)
                  ]),
                  _: 1
                }, 8, ["to", "class"]))
          ]),
          _createElementVNode("p", _hoisted_11, [
            _createVNode(_unref(TagIcon), {
              class: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString(__props.modelValue.mediaLabel || _ctx.$t('number.list.noMediaLabel')), 1)
          ]),
          _createElementVNode("p", _hoisted_12, [
            _createVNode(_unref(UsersIcon), {
              class: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('number.list.agentCount', __props.modelValue.usersNumber?.length || 0, {
                            named: { n: __props.modelValue.usersNumber?.length },
                        })), 1)
          ])
        ]),
        _createVNode(_component_UiAuditInfo, { "model-value": __props.modelValue }, null, 8, ["model-value"])
      ])
    ]),
    _: 1
  }))
}
}

})